import "./public-path";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import zhCN from 'antd/es/locale/zh_CN';

import "@/utils/rem";

import "@/assets/style/index.less";

// redux
import store from "./stores";

// router
import { rootRoutes, renderRoutes } from "@/routes";

let root: ReactDOM.Root;

function render(props: any) {
  const { container } = props;
  root = ReactDOM.createRoot(container ? container.querySelector("#root") : document.querySelector("#root"));
  root.render(
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <Suspense>
          <BrowserRouter basename="/">
            <Routes>{renderRoutes(rootRoutes)}</Routes>
          </BrowserRouter>
        </Suspense>
      </ConfigProvider>
    </Provider>
  );
}
render({});
